import type { Translation } from "../i18n-types.js"

const zh = {
  migration: "迁移",
  myBonds: "我的债券",
  oldWallet: "旧钱包",
  bond: "债券",
  network: "网络",
  date: "日期",
  status: "状态",
  continue: "继续",
  learnMore: "了解更多",
  later: "稍后",
  comingSoon: "即将上线...",
  transactions: "交易记录",
  price: "价格",
  backToHome: "返回首页",
  backToBonds: "返回债券列表",
  cancel: "取消",
  retry: "重试",
  notFound: "没有找到",
  pageError: "未知错误，请重试",
  copyErrorDetail: "复制错误详情",
  timeoutError: "请求超时，请重试",
  na: "无",
  auth: {
    authAndMigrate: "授权开始迁移",
    tips: "不会读取您的转账记录",
    title: "Mixin 资产迁移与债务",
    desc: "迁移旧钱包的资产到新钱包，同时记录 BTC、ETH 、USDT-ERC20 债务。",
    upgradeClient: "升级客户端",
    upgradeClientDesc: "当前客户端版本过低，请升级！",
    viewOldWallet: "查看旧网络钱包",
    checkPermissionOrUpgradeToSafe: "请检查权限或升级到 Safe",
    failedToGetClientVersion: "获取客户端版本失败",
  },
  home: {
    title: "Mixin 资产迁移",
    empty: "暂无可迁移资产",
  },
  migrationsPage: {
    learnMoreUrl: "https://support.mixin.one/zh/article/mdt-w0b7ju/",
    learnMoreBar: {
      title: "什么是 MDT？点击了解更多",
    },
    migrateID: "迁移 ID",
    pay: "支付 (旧钱包)",
    receive: "收到 (新钱包)",
    mixinSafeBond: "Mixin Safe Bond",
    bondPrice: "债券价格",
    bondRatio: "债券比例",
    migration: {
      title: "迁移 {symbol}",
      assetMigration: "资产迁移",
      assetMigrationDesc: "您即将迁移 {amount} {symbol}，迁移完成后您的新钱包将自动收到 {received} {symbol}。",
      assetBondMigrationDesc: "您即将迁移 {amount} {symbol}，迁移完成后您的新钱包将自动收到 {received} {symbol}，同时获得 {bond} {mdtSymbol} 债券，了解更多",
      boxBondMigrationDesc: "您即将迁移 {amount} {symbol}，迁移完成后您的新钱包将自动收到 {received} {symbol}，同时获得 {mdtbBond} MDTb 和 {mdteBond} MDTe 债券，了解更多",
      agreeContinue: "同意并继续",
      migratedSuccessfully: "迁移成功",
      amount: "数量",
    },
    records: {
      title: "迁移记录",
      migrated: "迁移了 {amount} {symbol}",
      received: "收到了 {amount} {symbol}",
      receivedWithBond: "收到了 {amount} {symbol} 和 {bond} {mdtSymbol}",
    },
    detail: {
      title: "迁移详情",
    },
  },
  bondsPage: {
    empty: "暂无债券",
    total: "总计",
    getBond: "获得 {mdtSymbol} 债券",
    detail: {
      title: "债券详情",
      bondId: "债券 ID",
      impairedAsset: "受损资产",
      registeredAt: "登记时间",
      claimedAt: "领取时间",
      transactionAt: "转账时间",
    },
    date: {
      registered: "已登记：{date}",
      claimed: "已领取：{date}",
    },
    receive: {
      title: "领取 MDT 代币",
      desc: "您可以领取 {amount} 债务代币，选择下面卡片然后再点击领取按钮领取代币，阅读文档了解更多。",
      mdtToken: "MDT 代币",
      mdtDesc: "领取 {mdts} 债务代币。",
      xinToken: "XIN 代币",
      xinDesc: "由于您的总债务小于或等于 100 MDT，您有且仅有一次机会以固定 {xinPrice} 美金的价格将其兑换为 XIN 代币。",
      receive: "领取",
      success: {
        title: "领取 {symbol} 代币",
        xinDesc: "您已成功将 {mdts} 债务代币以固定 {xinPrice} 美元的价格兑换成 {xin} XIN 代币，代币将按照您迁移次数和金额逐笔转账，排队转账中请耐心等候。",
        mdtDesc: "您已成功领取 {mdts} 债券代币，代币将按照您迁移次数和金额逐笔转账，排队转账中请耐心等候。",
        ok: "好的",
      },
      learnMoreUrl: "https://support.mixin.one/zh/article/mdt-19hntc6/",
    },
  },
} satisfies Translation

export default zh
